<template>
  <Head :title="`Edit ${site.name}`" />
  <DashboardLayout>
    <DContainer fluid>
      <DRow class="mb-4">
        <DCol>
          <div class="d-flex align-items-center gap-3">
            <Link href="/sites" class="btn btn-link text-dark p-0">
              <i-bi-arrow-left style="width: 24px; height: 24px" />
            </Link>
            <div>
              <h1 class="h3 mb-1">Edit {{ site.name }}</h1>
              <p class="text-muted mb-0">{{ site.editor_url }}</p>
            </div>
          </div>
        </DCol>
      </DRow>

      <DRow>
        <DCol lg="8" xl="6">
          <DCard class="border-0 shadow-sm">
            <SiteForm :site="site" />
          </DCard>

          <DCard class="border-0 shadow-sm border border-danger mt-4">
            <template #header>
              <h5 class="mb-0 text-danger">Danger Zone</h5>
            </template>
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted small">
                Removes the site and its check history. The editor itself is
                not touched.
              </div>
              <DButton variant="outline-danger" size="sm" @click="deleteSite">
                Delete Site
              </DButton>
            </div>
          </DCard>
        </DCol>
      </DRow>
    </DContainer>
  </DashboardLayout>
</template>

<script setup lang="ts">
import { Link, Head, router } from "@inertiajs/vue3";
import {
  DContainer,
  DRow,
  DCol,
  DCard,
  DButton,
} from "@omnitend/dashboard-for-laravel";
import DashboardLayout from "../../Layouts/DashboardLayout.vue";
import SiteForm from "./Form.vue";
import type { Site } from "../../types";

const props = defineProps<{
  site: Site;
}>();

const deleteSite = () => {
  if (
    !confirm(
      `Delete "${props.site.name}" and its check history? This cannot be undone.`,
    )
  ) {
    return;
  }

  router.delete(`/sites/${props.site.id}`);
};
</script>
